import React from 'react';
import styled from 'styled-components';
import { AdSlot } from 'app/components/ads/AdSlot';
import { AdUnit } from 'app/components/ads/AdUnit';
const StyledSponsorAdSlot = styled(AdSlot).withConfig({
  componentId: "sc-yxxuh-0"
})(["&&&{width:90px;height:34px;}"]);
const SponsorAdSlot = _ref => {
  let {
    extendSlotId
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledSponsorAdSlot, {
    noMargin: true,
    adSlotId: "ad-".concat(AdUnit.Sponsor_1, "-").concat(extendSlotId),
    adUnit: AdUnit.Sponsor_1,
    limitedDim: false,
    className: "",
    "data-sentry-element": "StyledSponsorAdSlot",
    "data-sentry-component": "SponsorAdSlot",
    "data-sentry-source-file": "SponsorAdSlot.tsx"
  });
};
export default SponsorAdSlot;